import {ReactNode, useEffect, useState} from 'react';
import {extractColors} from 'extract-colors';

interface PaletteState {
  loading: boolean;
  data: PaletteColors;
  error: Error | null;
}

export type PaletteColors = {
  [name: string]: string;
};

interface PaletteProps {
  src: string;
  children(palette: PaletteState): ReactNode;
}

/** Return the colors from the given(src) image url. */
export function ImagePaletteColors({src, children}: PaletteProps) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<PaletteColors>({});
  const [error, setError] = useState(null);

  useEffect(() => {
    extractColors(src)
      .then((colors) => {
        const colorMap: PaletteColors = colors.reduce<PaletteColors>((acc, color) => {
          acc[color.hex] = color.hex;
          return acc;
        }, {});
        setData(colorMap);
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  }, [src]);

  return <>{children({loading, data, error})}</>;
}
